import type { ReactNode } from 'react';

import styles from './DialogActions.module.css';

/**
 * The footer of a dialog form: Cancel then the primary action, right-aligned and separated from
 * the fields. Wraps on a narrow screen (the primary action stays last, full width on a phone).
 */
export function DialogActions({
  children,
  className,
  inline = false,
}: {
  children: ReactNode;
  className?: string;
  /** Keep the buttons in one row on a phone (for a few short actions) instead of a stack. */
  inline?: boolean;
}) {
  return (
    <div
      className={[styles.actions, inline && styles.inline, className].filter(Boolean).join(' ')}
      data-testid="dialog-actions"
    >
      {children}
    </div>
  );
}
